import { merge } from '@bingads-webui-universal/primitive-utilities';
import { isFunction, some, isEmpty } from 'underscore';

export function resolveStyles(theme, ...styles) {
  const resolvedStyles = styles.map(s => (isFunction(s) ? s(theme) : s));

  if (some(resolvedStyles, isEmpty)) {
    throw new Error('Cannot pass in empty style!');
  }
  return resolvedStyles;
}

export const mergeStyles = function mergeStyles({ theme }, ...styles) {
  const resolvedStyles = resolveStyles(theme, ...styles);
  // merge will keep other fields inside the objects and override the duplicated fields
  // and thus, the sequence may affect the results
  return merge({}, ...resolvedStyles);
};
